export const white = '#ffffff';

export const accent1Color = '#333';
export const alternateTextColor = white;
export const appBarColor = white;
export const archiveColor = '#cb1c1c';
export const body2Blue = '#007cd2';
export const borderColor = '#dddddd';
export const cardHeaderBackgroundColor = '#eaeaea';
export const disabledButtonColor = '#6dc7ff';
export const dropzoneBorderColor = '#d8d8d8';
export const errorBackgroundColor = '#ffdfdf';
export const errorTitleColor = '#d50000';
export const featuredGold = '#f4a802';
export const flatButtonTextColor = '#6e6e6e';
export const floatingLabelColor = '#9b9fa4';
export const helpTextColor = '#bdbdbd';
export const inactiveTabColor = '#cacaca';
export const landingPageBackground = white;
export const navTextColor = '#333';
// export const green = '#26b27d';
export const primary1Color = '#4878ff';
export const primary2Color = '#36a1e2';
export const primary3Color = '#087DC2';
export const primaryButtonColor = '#0a88d5';
export const secondaryButtonText = '#9d9d9d';
export const sellerLabsGreen = '#50c533';
export const sellerLabsMenuBackgroundColor = '#14151a';
export const titleBlue = '#1390d8';
export const userDropdownBackgroundColor = '#343640';

// New Colors
export const blue = '#00edff';
export const green = '#00ff8b';
export const red = '#ff0049';
export const purple = primary1Color;
// export const purple = '#6900ff';



// WEBPACK FOOTER //
// ./src/constants/colors.js